export default function getLogoBranding(type, url) {
  const 
    DEFAULT_LOGIN     = "/static/media/AssetVault_logo.28994f86.jpg", 
    DEFAULT_DASHBOARD = process.env.PUBLIC_URL + "/img/logo-text.png",
    DEFAULT_REPORT    = process.env.PUBLIC_URL + "/img/logo-assetvault-report.png"

  if(type === "login") {
    
    if(url === null || url === undefined || url === "") {
      return DEFAULT_LOGIN
    } else {
      return url
    }

  } else if(type === "dashboard") {

    if(url === null) {
      return DEFAULT_DASHBOARD
    } else {
      return url
    }

  } else if(type === "report") {

    if(url === null) {
      return DEFAULT_REPORT
    } else {
      return url
    }

  }

}


// WEBPACK FOOTER //
// ./src/App/utils/getLogoBranding.js